export default "__VITE_ASSET__d3dfc332__"